import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { buildPublicFileUrl } from "../config/api";
import "./Collections.css";

const collections = [
  /* =========================
     MAYACHITRO PHOTOGRAPHY
  ========================= */
  {
    id: "golden-river-sunsets",
    brand: "MayaChitro",
    group: "photography",
    label: "Photo Download",
    title: "Golden River Sunsets",
    description:
      "Warm river sunsets, glowing skies, silhouettes, and peaceful Bangladesh evening moods.",
    items: "Auto from database",
    price: "From $8.99",
    mood: "Warm · Calm · Cinematic",
    image: "/images/golden-sunset-river-mountains.jpg",
    link: "/shop?brand=mayachitro&collection=golden-river-sunsets",
  },
  {
    id: "bangladesh-sunsets",
    brand: "MayaChitro",
    group: "photography",
    label: "Photo Download",
    title: "Bangladesh Sunsets",
    description:
      "Curated sunset photographs from Bangladesh with soft light, riverside atmosphere, and quiet emotion.",
    items: "Auto from database",
    price: "From $8.99",
    mood: "Golden · Peaceful · Story-led",
    image: "/images/sunset-reflection-river-boat-silhouette-orange-glow-mayachitro.jpg",
    link: "/shop?brand=mayachitro&collection=bangladesh-sunsets",
  },
  {
    id: "river-life-stories",
    brand: "MayaChitro",
    group: "photography",
    label: "Photo Download",
    title: "River Life Stories",
    description:
      "Boats, fishers, river journeys, shorelines, and documentary moments from Bangladesh water life.",
    items: "Auto from database",
    price: "From $8.99",
    mood: "Peaceful · Documentary · Nostalgic",
    image: "/images/lone-boatman-river-serenity-landscape-mayachitro.jpg",
    link: "/shop?brand=mayachitro&collection=river-life-stories",
  },
  {
    id: "macro-details",
    brand: "MayaChitro",
    group: "photography",
    label: "Photo Download",
    title: "Nature & Macro",
    description:
      "Leaves, insects, water drops, textures, and close-up natural details for organic visual projects.",
    items: "Auto from database",
    price: "From $8.99",
    mood: "Fresh · Detailed · Organic",
    image: "/images/jumping-spider-on-green-leaf-macro-closeup-mayachitro.jpg",
    link: "/shop?brand=mayachitro&category=macro-details",
  },
  {
    id: "flowers-botanical",
    brand: "MayaChitro",
    group: "photography",
    label: "Photo Download",
    title: "Flowers & Botanical",
    description:
      "Soft blooms, floral colors, botanical closeups, and nature-inspired wall art visuals.",
    items: "Auto from database",
    price: "From $7.99",
    mood: "Soft · Colorful · Natural",
    image: "/images/bougainvillea-bloom-urban-architecture-bokeh-photography-mayachitro.jpg",
    link: "/shop?brand=mayachitro&category=flowers-botanical",
  },
  {
    id: "people-portrait",
    brand: "MayaChitro",
    group: "photography",
    label: "Photo Download",
    title: "People & Portraits",
    description:
      "Human stories, cultural portraits, emotional moments, and character-focused photography.",
    items: "Auto from database",
    price: "License varies",
    mood: "Human · Cultural · Emotional",
    image: "/images/emotional-child-portrait-holding-goat-black-and-white-photo-mayachitro.jpg",
    link: "/shop?brand=mayachitro&category=people-portrait",
  },
  {
    id: "architecture-places",
    brand: "MayaChitro",
    group: "photography",
    label: "Photo Download",
    title: "Architecture & Places",
    description:
      "Interiors, monuments, structures, travel places, and architectural visual stories.",
    items: "Auto from database",
    price: "From $8.99",
    mood: "Historic · Elegant · Place-based",
    image: "/images/modern-architecture-golden-grid-facade-evening-sky-cloudscape-mayachitro.jpg",
    link: "/shop?brand=mayachitro&category=architecture-places",
  },
  {
    id: "abstract-minimal-photo",
    brand: "MayaChitro",
    group: "photography",
    label: "Photo Download",
    title: "Abstract & Minimal",
    description:
      "Minimal forms, natural patterns, soft texture, and quiet photographic compositions.",
    items: "Auto from database",
    price: "From $8.99",
    mood: "Minimal · Modern · Calm",
    image: "/images/half-colored-leaf-closeup-black-green-tones-nature-pattern-mayachitro.jpg",
    link: "/shop?brand=mayachitro&category=abstract-minimal",
  },
  {
    id: "wildlife-birds",
    brand: "MayaChitro", group: "photography", label: "Photo Download",
    title: "Wildlife & Birds",
    description: "Birds in flight, quiet wildlife encounters, and expressive natural moments.",
    items: "Curated collection", price: "From $8.99", mood: "Wild Â· Airy Â· Observational",
    image: "/images/black-headed-gull-flying-over-sea-closeup-bird-motion-mayachitro.jpg",
    link: "/shop?brand=mayachitro&category=wildlife-birds",
  },
  {
    id: "city-street-photography",
    brand: "MayaChitro", group: "photography", label: "Photo Download",
    title: "City & Street Photography",
    description: "Street scenes, movement, people, markets, and the visual energy of everyday life.",
    items: "Curated collection", price: "From $8.99", mood: "Urban Â· Human Â· Energetic",
    image: "/images/dhaka-night-long-exposure-traffic-trails-metro-rail-cityscape.jpg",
    link: "/shop?brand=mayachitro&category=city-street",
  },
  {
    id: "travel-places",
    brand: "MayaChitro", group: "photography", label: "Photo Download",
    title: "Travel & Places",
    description: "Sense of place through roads, water, architecture, horizons, and distant journeys.",
    items: "Curated collection", price: "From $8.99", mood: "Wandering Â· Open Â· Memorable",
    image: "/images/tropical-river-hill-view.jpg",
    link: "/shop?brand=mayachitro&category=travel-places",
  },
  {
    id: "rural-life-documentary",
    brand: "MayaChitro", group: "photography", label: "Photo Download",
    title: "Rural Life & Documentary",
    description: "Grounded stories of work, culture, boats, families, and life along Bangladesh's rivers.",
    items: "Curated collection", price: "From $8.99", mood: "Real Â· Cultural Â· Story-led",
    image: "/images/fisherman-and-wife-on-wooden-boat-bangladesh-river-life-mayachitro.jpg",
    link: "/shop?brand=mayachitro&category=rural-documentary",
  },

  /* =========================
     CLOUDY PIXEL STUDIO
  ========================= */
  {
    id: "rainy-lantern-streets",
    brand: "Cloudy Pixel Studio",
    group: "wall-art",
    label: "Printable Wall Art",
    title: "Rainy Lantern Streets",
    description:
      "Moody rainy alleys, glowing lamps, cozy storefronts, and cinematic printable wall art.",
    items: "Auto from database",
    price: "From $5.99",
    mood: "Moody · Cozy · Cinematic",
    image:
      "/uploads/public/products/cloudy-pixel-studio/wall-art-posters/cps-0001-rainy-japanese-teahouse-alley/cover.webp",
    link: "/shop?brand=cloudy-pixel-studio&collection=rainy-lantern-streets",
  },
  {
    id: "vintage-animal-posters",
    brand: "Cloudy Pixel Studio",
    group: "wall-art",
    label: "Printable Wall Art",
    title: "Vintage Animal Posters",
    description:
      "Vintage animals, cats, birds, wildlife, and character-style printable posters for cozy decor.",
    items: "Auto from database",
    price: "From $5.99",
    mood: "Vintage · Warm · Giftable",
    image:
      "/uploads/public/products/cloudy-pixel-studio/wall-art-posters/cps-0002-vintage-black-cat-orange-sun-poster/cover.webp",
    link: "/shop?brand=cloudy-pixel-studio&collection=vintage-animal-posters",
  },
  {
    id: "moody-bird-posters",
    brand: "Cloudy Pixel Studio",
    group: "wall-art",
    label: "Printable Wall Art",
    title: "Moody Bird Posters",
    description:
      "Elegant bird-inspired printable wall art with calm atmosphere and refined interior mood.",
    items: "Auto from database",
    price: "From $5.99",
    mood: "Moody · Elegant · Quiet",
    image:
      "/uploads/public/products/cloudy-pixel-studio/wall-art-posters/cps-0004-moody-white-heron-blue-reflection-poster/moody-white-heron-blue-reflection-printable-wall-art-cover.webp",
    link: "/shop?brand=cloudy-pixel-studio&collection=moody-bird-posters",
  },
  {
    id: "white-flower-botanical-prints",
    brand: "Cloudy Pixel Studio",
    group: "wall-art",
    label: "Printable Wall Art",
    title: "White Flower Botanical Prints",
    description:
      "Soft botanical flower prints for bedrooms, gallery walls, offices, and peaceful decor.",
    items: "Auto from database",
    price: "From $5.99",
    mood: "Botanical · Soft · Refined",
    image:
      "/uploads/public/products/cloudy-pixel-studio/wall-art-posters/cps-0005-white-hellebore-red-botanical-print/white-hellebore-red-botanical-print-cover.webp",
    link: "/shop?brand=cloudy-pixel-studio&collection=white-flower-botanical-prints",
  },
  {
    id: "sunflower-botanical-prints",
    brand: "Cloudy Pixel Studio",
    group: "wall-art",
    label: "Printable Wall Art",
    title: "Sunflower Botanical Prints",
    description:
      "Bright sunflower printable wall art for warm, cheerful, and nature-inspired interiors.",
    items: "Auto from database",
    price: "From $5.99",
    mood: "Sunny · Natural · Fresh",
    image:
      "/uploads/public/products/cloudy-pixel-studio/wall-art-posters/cps-0007-sunflower-botanical-print/sunflower-botanical-print-cover.webp",
    link: "/shop?brand=cloudy-pixel-studio&collection=sunflower-botanical-prints",
  },
  {
    id: "cowboy-frog-prints",
    brand: "Cloudy Pixel Studio",
    group: "wall-art",
    label: "Printable Wall Art",
    title: "Cowboy Frog Prints",
    description:
      "Whimsical frog wall art with playful character, vintage western mood, and gift-ready charm.",
    items: "Auto from database",
    price: "From $5.99",
    mood: "Whimsical · Fun · Giftable",
    image:
      "/uploads/public/products/cloudy-pixel-studio/wall-art-posters/cps-0008-cowboy-frog-western-print/cowboy-frog-western-print-cover.webp",
    link: "/shop?brand=cloudy-pixel-studio&collection=cowboy-frog-prints",
  },
  {
    id: "vintage-dance-wall-art",
    brand: "Cloudy Pixel Studio",
    group: "wall-art",
    label: "Printable Wall Art",
    title: "Vintage Dance Wall Art",
    description:
      "Warm music, dance, record-inspired printable wall art for nostalgic and cozy rooms.",
    items: "Auto from database",
    price: "From $5.99",
    mood: "Vintage · Romantic · Warm",
    image:
      "/uploads/public/products/cloudy-pixel-studio/wall-art-posters/cps-0006-vintage-couple-dancing-vinyl-record-poster/vintage-couple-dancing-vinyl-record-poster-cover.webp",
    link: "/shop?brand=cloudy-pixel-studio&collection=vintage-dance-wall-art",
  },
];

function getAssetUrl(path) {
  if (!path) return "";

  if (path.startsWith("http")) return path;

  if (path.startsWith("/uploads") || path.startsWith("uploads/")) {
    return buildPublicFileUrl(path);
  }

  return path;
}

function Collections() {
  const [activeFilter, setActiveFilter] = useState("all");

  useEffect(() => {
    document.title = "Photography Collections | Fine Art Prints & Digital Downloads | MayaChitro";
  }, []);

  const filteredCollections = useMemo(() => {
    const mayaCollections = collections.filter((item) => item.group === "photography");
    if (activeFilter === "all") return mayaCollections;
    return mayaCollections.filter((item) => item.group === activeFilter);
  }, [activeFilter]);

  const photographyCollections = filteredCollections.filter(
    (item) => item.group === "photography"
  );

  const wallArtCollections = [];

  return (
    <main className="mc-collections-page">
      <section className="mc-collections-hero">
        <div>
          <p className="mc-collections-kicker">Collections</p>
          <h1>Browse photography by mood, story, and use.</h1>
          <p>
            Discover original Bangladesh photography for wall art, interiors,
            editorial projects, and thoughtful gifts. Browse river sunsets,
            wildlife, portraits, botanical details, and more in ready-to-buy
            digital collections.
          </p>
        </div>

        <div className="mc-collections-actions">
          <Link to="/shop" className="mc-collections-btn primary">
            Shop All
          </Link>
          <Link to="/licensing" className="mc-collections-btn secondary">
            Licensing
          </Link>
        </div>
      </section>

      <section className="mc-collections-proof" aria-label="Why shop MayaChitro collections">
        <div><strong>Original photography</strong><span>Made in the field, not generated.</span></div>
        <div><strong>Instant digital access</strong><span>High-resolution files after purchase.</span></div>
        <div><strong>Flexible licensing</strong><span>Personal, editorial, and commercial use.</span></div>
        <div><strong>Curated for real spaces</strong><span>Images selected for homes and creative work.</span></div>
      </section>

      <section className="mc-collections-filter" aria-label="Collection filters">
        <button
          type="button"
          className={activeFilter === "all" ? "active" : ""}
          onClick={() => setActiveFilter("all")}
        >
          All
        </button>

        <button
          type="button"
          className={activeFilter === "photography" ? "active" : ""}
          onClick={() => setActiveFilter("photography")}
        >
          MayaChitro Photography
        </button>

      </section>

      {photographyCollections.length > 0 && (
        <section className="mc-collections-section">
          <div className="mc-collections-section-head">
            <div>
              <p className="mc-collections-kicker">MayaChitro Photography</p>
              <h2>Photography Collections</h2>
              <p>
                Browse photo downloads, wall art, and image licenses by subject,
                mood, and story.
              </p>
            </div>

            <Link to="/shop?brand=mayachitro">Shop MayaChitro Photos →</Link>
          </div>

          <div className="mc-collections-grid">
            {photographyCollections.map((item) => (
              <CollectionCard key={item.id} item={item} />
            ))}
          </div>
        </section>
      )}

      {wallArtCollections.length > 0 && (
        <section className="mc-collections-section">
          <div className="mc-collections-section-head">
            <div>
              <p className="mc-collections-kicker">Cloudy Pixel Studio</p>
              <h2>Printable Wall Art Collections</h2>
              <p>
                Explore digital posters and printable wall art for home decor,
                gallery walls, gifts, and styled interiors.
              </p>
            </div>

            <Link to="/shop?brand=cloudy-pixel-studio">Explore Wall Art →</Link>
          </div>

          <div className="mc-collections-grid">
            {wallArtCollections.map((item) => (
              <CollectionCard key={item.id} item={item} />
            ))}
          </div>
        </section>
      )}

      <section className="mc-collections-license-cta">
        <div>
          <p className="mc-collections-kicker">Usage & Licensing</p>
          <h2>Need photos for wall art, editorial use, or commercial projects?</h2>
          <p>
            Explore product collections, choose the right license, and move
            directly to checkout when you are ready.
          </p>
        </div>

        <div className="mc-collections-actions">
          <Link to="/licensing" className="mc-collections-btn primary">
            Learn Licensing
          </Link>
          <Link to="/shop" className="mc-collections-btn secondary">
            Browse Products
          </Link>
        </div>
      </section>
    </main>
  );
}

function CollectionCard({ item }) {
  const displayMood = item.mood.replace(/Â/g, "");
  const displayItems = item.items === "Auto from database" ? "Curated collection" : item.items;

  return (
    <Link to={item.link} className="mc-collection-card">
      <div className="mc-collection-image-wrap">
        <img
          src={getAssetUrl(item.image)}
          alt={`${item.title} collection`}
          loading="lazy"
        />
        <div className="mc-collection-image-overlay" />
      </div>

      <div className="mc-collection-content">
        <span className="mc-collection-label">{item.label}</span>

        <div className="mc-collection-title-row">
          <h3>{item.title}</h3>
          <span>View →</span>
        </div>

        <p>{item.description}</p>

        <div className="mc-collection-meta">
          <span>{displayItems}</span>
          <span>{item.price}</span>
          <span>{displayMood}</span>
        </div>
      </div>
    </Link>
  );
}

export default Collections;
